module.exports = __webpack_public_path__ + "media/images/icons/ic-login-14931651b12893666b2f6c2050486bb9.svg";